import columnTypes from '../columnTypes.js';
import types from '../types.js';

const myGlobalSearchTables = [
  {
    key: 'global-search-result',
    name: 'Global Search Result',
    [columnTypes.default.key]: [
      {
        source: 'AssetName',
        rename: 'Asset Name',
        type: types.text,
      },
      {
        source: 'AssetType',
        rename: 'Asset Type',
        type: types.text,
      },
      {
        source: 'AssociatedModule',
        rename: 'Associated Module',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [{ source: '_Id', rename: 'Asset ID' }],
  },
];

export default [...myGlobalSearchTables];
